
import components from './components/index.js';
import dialogs from './dialogs/index.js';
import pages from './pages/index.js';
import appcaches from './caches/index.js';
import plugins from './plugins/index.js';
import package_json from '../package.json';

(function() {	
	window.Grape.modules.push(package_json);

	window.Grape.dialog.registerDialogs(dialogs);
	window.Grape.pages.registerPages(pages);
	window.Grape.component.registerComponents(components);
	window.Grape.cache.registerCaches(appcaches);

	Grape.registry.addItem(
		'PSServerDashboardPages',
		`${pages[0].title}`,
		{
			title: pages[0].title,
			icon: pages[0].icon,
			page_id: pages[0].page_id || pages[0].route || null,
			idx: pages[0].idx
		}
	);
		
	Grape.registry.addItem('DashboardPanelType', 'ChartDisplay',
	{
		name: 'ChartDisplay',
		component: 'chart-display-panel',
		title: '',
		actions: [
			{name: 'view-graph', icon: 'fa fa-eye', title: 'View Graph', type: 'url', paramater_value: 'chart_name'},
			{name: 'share-graph', icon: 'fa fa-share-nodes', title: 'Share Graph'},
			{name: 'print', icon: 'fa fa-print', title: 'Print'},
			{name: 'download', icon: 'fa fa-file-pdf', title: 'Download'},
			{name: 'expand', icon: 'fa fa-up-right-and-down-left-from-center', title: 'Expand'}
		],
		ui_fields: [
			{name: 'chart_name', type: 'list', title: 'Chart name', items_from_cache: 'ChartsList', list_label_field: 'name', list_value_field: 'name' },
			{name: 'title', type: 'text', title: 'Title'},
			{name: 'chart_height', type: 'integer', title: 'Chart height'},
			{name: 'chart_width', type: 'integer', title: 'Chart width'},
			{name: 'use_filter', type: 'boolean', title: 'Use Filter'},
			{name: 'use_date', type: 'boolean', title: 'Use Sate Filter'},
			{name: 'use_dropdown', type: 'boolean', title: 'Use Dropdown Filter'},
			{name: 'date_filter_column', type: 'text', title: 'Date Filter Column'},
			{name: 'date_params', type: 'json', title: 'Date List Params'},
			{name: 'dropdown_filter_column', type: 'text', title: 'Dropdown Filter Column'},
			{name: 'dropdown_params', type: 'json', title: 'Dropdown List Params'},	
			{name: 'url', type: 'url', Label: 'Url'},
			{name: 'show_data', type: 'boolean', title: 'Show Data'}
		]
	});

})();

